export const RoleBadge = ({ role }) => {
  if (!role) return null;
  const tech = role === "tech";
  return (
    <span data-testid="role-badge" className={`rounded-full border px-2 py-0.5 font-mono text-[10px] uppercase tracking-wider ${tech ? "border-rose-200 bg-rose-100 text-rose-800" : "border-amber-200 bg-amber-100 text-amber-800"}`}>
      {tech ? "Nail tech" : "Client"}
    </span>
  );
};
